import React from "react";
import { Lock } from "lucide-react";
import { isMissionLocked } from "../content/missions";

// Mission artwork, or a placeholder emblem until the art is added.
export default function MissionArt({ mission, className = "" }) {
  const locked = isMissionLocked(mission);
  if (mission.image && !locked) {
    return (
      <div className={`relative ${className}`}>
        <img
          src={mission.image}
          alt={mission.name}
          className={`absolute inset-0 w-full h-full object-contain ${mission.glow || ""}`}
          decoding="async"
        />
      </div>
    );
  }
  return (
    <div
      className={`relative flex items-center justify-center border border-dashed brushed ${className}`}
      style={{ borderColor: locked ? "#2A3040" : `${mission.accent}66` }}
      aria-hidden="true"
    >
      <div className="absolute inset-0 scanlines" />
      <div className="text-center">
        {locked ? (
          <Lock className="w-12 h-12 mx-auto text-[#8A91A0]" />
        ) : (
          <div
            className="font-display text-7xl md:text-8xl leading-none"
            style={{ color: mission.accent, textShadow: `0 0 30px ${mission.accent}55` }}
          >
            {mission.code}
          </div>
        )}
        <div className="mt-3 font-mono text-[9px] uppercase tracking-[0.35em] text-[#8A91A0]">
          {locked ? "Access Denied" : "Mission Insignia"}
        </div>
      </div>
    </div>
  );
}
